import { Divider, Typography } from 'antd';
import React, { Fragment, memo } from 'react';

const { Title, Text } = Typography;

interface IFollowUpRepairs {
  description: string;
  awNumber: string;
  value: number;
}

interface IMaintenanceSubTask {
  name: string;
  mandatoryReplacement: boolean;
  longDescriptions: string[];
  remark: string;
  followUpRepairs: IFollowUpRepairs[];
}

interface IMaintenance {
  name: string;
  mandatoryReplacement: boolean;
  subTasks: IMaintenanceSubTask[];
}

interface IProps {
  maintenance: IMaintenance;
}

export const Maintenance: React.FC<IProps> = memo(({ maintenance }) => {
  return (
    <>
      {maintenance && (
        <>
          <Title level={4}>{maintenance.name}</Title>
          <br />
          {maintenance.subTasks?.map((subTask, index) => {
            return (
              <Fragment key={`${subTask.name}${index}`}>
                <Title level={5}>
                  {subTask.name} {subTask.remark}
                </Title>
                {subTask.longDescriptions &&
                  subTask.longDescriptions.map((description, index) => {
                    return (
                      <Fragment key={`${description}${index}`}>
                        <Text>{description}</Text>
                        <br />
                      </Fragment>
                    );
                  })}
                {subTask.followUpRepairs &&
                  subTask.followUpRepairs.map((repairs, index) => {
                    return (
                      <Fragment key={`${repairs}${index}`}>
                        <Text>{repairs.description}</Text>
                        <br />
                      </Fragment>
                    );
                  })}
                {subTask.mandatoryReplacement !== undefined && (
                  <Fragment>
                    <Text>{`Mandatory replacement: ${subTask.mandatoryReplacement ? 'Yes' : 'No'} `}</Text>
                    <br />
                  </Fragment>
                )}
                <br />
              </Fragment>
            );
          })}
          <Divider />
        </>
      )}
    </>
  );
});
